"use strict";

var getValueOfKeyMatching = require('../getValueOfKeyMatching');

function CustomSigns(params) {
  var product_size = getValueOfKeyMatching(params, /^custom_sign_size/);
  var product_orientation = getValueOfKeyMatching(params, /sign_orientation/).slice(0, 1); // 'L' or 'P'

  var quantity = parseInt(getValueOfKeyMatching(params, /sign_quantity/).replace(/[\ssetS]/g, ''), 10) || 0;
  var personalization = getValueOfKeyMatching(params, /sign_wording/);

  if (personalization) {
    this.personalization.push({
      name: 'Wording',
      value: personalization
    });
  }

  this.customSigns.add({
    quantity: quantity,
    product_size: product_size,
    product_orientation: product_orientation,
    personalization: personalization
  });
}

module.exports = CustomSigns;